var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 152,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M81.25 14.5v100h-37.5v-75H6.25v-25a6.25 6.25 0 0 1 6.25-6.25h25a6.25 6.25 0 0 1 6.25 6.25A6.25 6.25 0 0 1 50 8.25h25a6.25 6.25 0 0 1 6.25 6.25Zm70.234 116.875L145 107.234 108.75 117l6.484 24.14a6.253 6.253 0 0 0 7.657 4.375l24.14-6.484a6.257 6.257 0 0 0 3.817-2.903 6.243 6.243 0 0 0 .636-4.753ZM119.141 10.672a6.328 6.328 0 0 0-7.657-4.453l-24.14 6.484a6.329 6.329 0 0 0-4.453 7.656l6.484 24.14 36.25-9.687-6.484-24.14Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7C7C",
    d: "M6 10h36v27H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7CBE9B",
    d: "M46 144h36v-27H46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#917CBE",
    d: "m119.029 143.667 30.602-7.936-6.778-26.136-30.602 7.937zM90.778 43.072l30.602-7.937L114.602 9 84 16.936z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4747",
    d: "M6 43h36v101H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47DB8B",
    d: "M46 111h36V10H46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7647DB",
    d: "m110.745 111.725 30.605-7.937-16.843-64.947-30.606 7.938z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.5 129.812 125.156 9.031A12.497 12.497 0 0 0 109.844.203l-24.14 6.484-.782.235A12.5 12.5 0 0 0 75 2H50c-2.2.006-4.357.599-6.25 1.718A12.344 12.344 0 0 0 37.5 2h-25A12.5 12.5 0 0 0 0 14.5v125A12.502 12.502 0 0 0 12.5 152h25c2.2-.006 4.357-.6 6.25-1.719A12.35 12.35 0 0 0 50 152h25a12.5 12.5 0 0 0 12.5-12.5V61.687l21.719 81.016A12.499 12.499 0 0 0 121.328 152a15.561 15.561 0 0 0 3.203-.391l24.141-6.484a12.504 12.504 0 0 0 8.828-15.313Zm-60.469-80.86 24.141-6.483 16.172 60.39-24.141 6.484-16.172-60.39Zm16.016-36.64 4.922 18.047-24.14 6.484-4.923-18.046 24.141-6.485ZM75 14.5v93.75H50V14.5h25Zm-37.5 0v18.75h-25V14.5h25Zm-25 125V45.75h25v93.75h-25Zm62.5 0H50v-18.75h25v18.75Zm70.469-6.485-24.141 6.485-4.922-18.125 24.219-6.485 4.844 18.125Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h158v152H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.3eef761fb9a2cffa0fc4498b48a72e87.svg";
export { ForwardRef as ReactComponent };